window.onscroll = function() { stickyHeader() };

function stickyHeader() {
  if (window.pageYOffset > 48 || ('ontouchstart' in window || 'ontouch' in window)) {
    document.body.classList.add("sticky-header");
  } else {
    document.body.classList.remove("sticky-header");
  }
}